export default __webpack_public_path__ + "static/logo-disney-plus-6248ca1769d80969e24ef2aef4035dfe.png";